import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./TeamRequests.css";
import PopupMessage from "../PopupMessage/PopupMessage";
import { 
  fetchTeamRequests, 
  updatePilotStatus
} from "../Apis/AdminApis";
import pavamanLogo from "../images/drone.png";
import { useNavigate } from "react-router-dom";

const TeamRequests = () => {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState("grid");
  const [selectedPilot, setSelectedPilot] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionPilot, setActionPilot] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [isActionProcessing, setIsActionProcessing] = useState(false); 
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const statusMap = {
    0: { label: "Pending", value: "pending", color: "#FFA500", bg: "#FFF3CD", icon: "⏳" },
    1: { label: "Approved", value: "approved", color: "#00B894", bg: "#D4EDDA", icon: "✓" },
    2: { label: "Rejected", value: "rejected", color: "#FF4757", bg: "#F8D7DA", icon: "✗" },
    3: { label: "Blocked", value: "blocked", color: "#6C757D", bg: "#E2E3E5", icon: "🚫" }
  };

  useEffect(() => {
    loadTeamRequests();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [filter, searchTerm]);

  // const getPilotStatusFromDevices = (devices) => {
  //   if (!devices || devices.length === 0) return statusMap[0];
  //   // const hasApproved = devices.some(device => device.admin_approved === 1 && device.is_active === true);

  //   const hasPending = devices.some(device => device.admin_approved === 0);
  //   const hasRejected = devices.some(device => device.admin_approved === 2);
    
  //   if (hasApproved) return statusMap[1];
  //   else if (hasPending) return statusMap[0];
  //   else if (hasRejected && !hasPending && !hasApproved) return statusMap[2];
  //   return statusMap[3];
  // };

  // const getDeviceInfoFromDevices = (devices) => {
  //   if (!devices || devices.length === 0) {
  //     return {
  //       device_id: "Not Set",
  //       device_count: 0,
  //       pending_devices: [],
  //       approved_devices: [],
  //       rejected_devices: []
  //     };
  //   }
  //   const pending_devices = devices.filter(d => d.admin_approved === 0);
  //   const approved_devices = devices.filter(d => d.admin_approved === 1 && d.is_active === true);
  //   const rejected_devices = devices.filter(d => d.admin_approved === 2);
  //   return {
  //     device_id: devices[0]?.device_id || `DEV-${devices[0]?.id || '001'}`,
  //     device_count: devices.length,
  //     pending_devices,
  //     approved_devices,
  //     rejected_devices
  //   };
  // };

  const getDeviceInfoFromDevices = (devices) => {
  if (!devices || devices.length === 0) {
    return {
      device_id: "Not Set",
      device_count: 0,
      latest_device: null,
      is_active: false,
      admin_approved: null,
      pending_devices: [],
      approved_devices: [],
      rejected_devices: []
    };
  }

  // Get the latest device based on created_on
  const sortedDevices = [...devices].sort(
    (a, b) =>
      new Date(b.created_on).getTime() -
      new Date(a.created_on).getTime()
  );

  const latestDevice = sortedDevices[0];

  // Pilot is active ONLY when latest device is approved AND active
  const latestDeviceIsActive =
    latestDevice?.admin_approved === 1 &&
    latestDevice?.is_active === true;

  const pending_devices = devices.filter(
    d => d.admin_approved === 0
  );

  const rejected_devices = devices.filter(
    d => d.admin_approved === 2
  );

  return {
    device_id: latestDevice?.device_id || "Not Set",
    device_count: devices.length,

    // Latest device only
    latest_device: latestDevice,
    is_active: latestDeviceIsActive,
    admin_approved: latestDevice?.admin_approved ?? null,

    pending_devices,
    rejected_devices,

    // Only latest device can be considered active
    approved_devices: latestDeviceIsActive
      ? [latestDevice]
      : []
  };
};

  // const loadTeamRequests = async () => {
  //   setLoading(true);
  //   const res = await fetchTeamRequests({});
  //   if (res?.error) {
  //      if (res?.error?.includes("Unauthorized")) {
  //       setPopupMessage("Session expired, redirecting to login page");
  //       setPopupType("error");
  //       setPopupOpen(true);

  //       setTimeout(() => {
  //         navigate("/login");
  //       }, 2000);

  //       setLoading(false);
  //       return;
  //     }

  //     console.error(res.error);

  //     setPopupMessage(res.error);
  //     setPopupType("error");
  //     setPopupOpen(true);

  //     setLoading(false);
  //     return;
  //   }
  //   const formattedData = res.pilots.map((pilot) => {
  //     const devices = pilot.devices || [];
  //     const status = getPilotStatusFromDevices(devices);
  //     const deviceInfo = getDeviceInfoFromDevices(devices);

  //     return {
  //       id: pilot.id,
  //       name: pilot.name || "Unknown Pilot",
  //       firstName: pilot.name?.split(" ")[0] || "",
  //       lastName: pilot.name?.split(" ").slice(1).join(" ") || "",
  //       email: pilot.email,
  //       mobile_no: pilot.mobile_no,
  //       company_name: pilot.company_name,
  //       admin_id: pilot.admin_id,
  //       admin_name: pilot.admin_name,
  //       is_superadmin_company: pilot.is_superadmin_company,
  //       status: status.value,
  //       statusLabel: status.label,
  //       statusColor: status.color,
  //       statusBg: status.bg,
  //       statusIcon: status.icon,
  //       devices,
  //       device_count: deviceInfo.device_count,
  //       device_id: deviceInfo.device_id,
  //       pending_devices: deviceInfo.pending_devices,
  //       approved_devices: deviceInfo.approved_devices,
  //       rejected_devices: deviceInfo.rejected_devices,
  //       login_on: pilot.login_on,
  //       login_status: pilot.login_status,
  //       logout_status: pilot.logout_status,
  //       logout_on: pilot.logout_on,
  //       created_on: pilot.created_on,
  //       created_on_full: pilot.created_on,
  //       login_on_full: pilot.login_on || null,
  //       logout_on_full: pilot.logout_on || null
  //     };
  //   });
  //   setRequests(formattedData);
  //   setCurrentPage(1);
  //   setLoading(false);
  // };

const loadTeamRequests = async () => {
  setLoading(true);

  const res = await fetchTeamRequests({});

  if (res?.error) {
    if (res?.error?.includes("Unauthorized")) {
      setPopupMessage("Session expired, redirecting to login page");
      setPopupType("error");
      setPopupOpen(true);

      setTimeout(() => {
        navigate("/login");
      }, 2000);

      setLoading(false);
      return;
    }

    console.error(res.error);

    setPopupMessage(res.error);
    setPopupType("error");
    setPopupOpen(true);

    setLoading(false);
    return;
  }

  // ------------------------------------------
  // FILTER PILOTS BASED ON ADMIN
  // ------------------------------------------

  let pilots = res?.pilots || [];

  if (res?.view_mode === "admin") {
    const loggedInAdminId = Number(
      sessionStorage.getItem("adminId")
    );

    if (loggedInAdminId) {
      pilots = pilots.filter(
        pilot => Number(pilot.admin_id) === loggedInAdminId
      );
    }
  }

  // ------------------------------------------
  // FORMAT PILOT DATA
  // ------------------------------------------

const formattedData = pilots.map((pilot) => {
  const devices = pilot.devices || [];

  // Get latest device
  const deviceInfo = getDeviceInfoFromDevices(devices);

  // Status is based on the latest device approval status.
  // Backend updates PilotDeviceAccess.admin_approved.
  const deviceStatus = Number(deviceInfo.admin_approved);

  const status =
    statusMap[deviceStatus] || statusMap[0];

  return {
      id: pilot.id,

      name: pilot.name || "Unknown Pilot",
      firstName: pilot.name?.split(" ")[0] || "",
      lastName:
        pilot.name?.split(" ").slice(1).join(" ") || "",

      email: pilot.email,
      mobile_no: pilot.mobile_no,

      company_name: pilot.company_name,
      admin_id: pilot.admin_id,
      admin_name: pilot.admin_name,
      is_superadmin_company:
        pilot.is_superadmin_company,
is_dgca_company: pilot.is_dgca_company,
      // Pilot/account status
pilot_status: pilot.status,

// Device approval status
device_status: deviceInfo.admin_approved,

      status: status.value,
      statusLabel: status.label,
      statusColor: status.color,
      statusBg: status.bg,
      statusIcon: status.icon,

      signup_key: pilot.signup_key || null,

      // ------------------------------------------
      // LATEST DEVICE INFORMATION
      // ------------------------------------------

      device_count: deviceInfo.device_count,

      device_id: deviceInfo.device_id,

      latest_device: deviceInfo.latest_device,

      is_active: deviceInfo.is_active,

      admin_approved: deviceInfo.admin_approved,

      pending_devices:
        deviceInfo.pending_devices,

      approved_devices:
        deviceInfo.approved_devices,

      rejected_devices:
        deviceInfo.rejected_devices,

      // Login
      login_on: pilot.login_on,
      login_status: pilot.login_status,
      logout_status: pilot.logout_status,
      logout_on: pilot.logout_on,

      // Dates
      created_on: pilot.created_on,
      created_on_full: pilot.created_on,
      login_on_full: pilot.login_on || null,
      logout_on_full: pilot.logout_on || null
    };
  });

  setRequests(formattedData);
  setCurrentPage(1);
  setLoading(false);
};

  const handleStatusUpdate = async (pilot, action) => {
    try {
      setIsActionProcessing(true);
      
      const adminApprovedValue = action === 'approve' ? 1 : 2;
      
      const payload = { 
        pilot_email: pilot.email, 
        admin_approved: adminApprovedValue 
      };
      
      const res = await updatePilotStatus(payload);
      
      if (res?.error) {
        setPopupMessage(res.error);
        setPopupType("error");
        setPopupOpen(true);
        setIsActionProcessing(false);
        return;
      }
      
      const successMessage = res?.message || 
        (action === 'approve' ? "Pilot approved successfully" : "Pilot rejected and device blocked successfully");
      
      setPopupMessage(successMessage);
      setPopupType("success");
      setPopupOpen(true);
      setShowActionModal(false);
      setActionPilot(null);
      setActionType(null);
      await loadTeamRequests();
    } catch (err) {
      console.error(err);
       if (
      err?.response?.status === 401 ||
      err?.response?.data?.error?.includes("Unauthorized")
    ) {
      setPopupMessage("Session expired, redirecting to login page");
      setPopupType("error");
      setPopupOpen(true);

      setTimeout(() => {
        navigate("/login");
      }, 2000);

      return;
    }

      setPopupMessage(err?.response?.data?.error || "Failed to update pilot status");
      setPopupType("error");
      setPopupOpen(true);
    } finally {
      setIsActionProcessing(false); 
    }
  };

  const openActionModal = (pilot, type) => {
    setActionPilot(pilot);
    setActionType(type);
    setShowActionModal(true);
  };

  const closeActionModal = () => {
    if (isActionProcessing) return; 
    setShowActionModal(false);
    setActionPilot(null);
    setActionType(null);
  };

  const handleViewClick = (pilot) => {
    navigate("/admin/teams/active/pilot-details", {
      state: { pilot, from: "requests" }
    });
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setSelectedPilot(null);
  };

  const filteredRequests = requests.filter((req) => {
    const matchesFilter = filter === "all" || req.status === filter;
    const matchesSearch = req.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.mobile_no?.includes(searchTerm);
    return matchesFilter && matchesSearch;
  });
  
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRequests = filteredRequests.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);
  
  const statusCounts = {
    all: requests.length,
    pending: requests.filter(r => r.status === "pending").length,
    approved: requests.filter(r => r.status === "approved").length,
    rejected: requests.filter(r => r.status === "rejected").length,
    blocked: requests.filter(r => r.status === "blocked").length,
  };
  
  const formatMobile = (mobile) => !mobile ? "N/A" : mobile.startsWith('+91') ? mobile : `+91 ${mobile}`;
  const formatDate = (dateString) => !dateString ? "Never" : new Date(dateString).toLocaleDateString();
  const formatDateTime = (dateString) => !dateString ? "Never" : new Date(dateString).toLocaleString();

  const renderActionButtons = (pilot) => {
    switch (pilot.status) {
      case "pending":
        return (
          <div className="tr-action-buttons">
            <button className="tr-btn-approve" onClick={() => openActionModal(pilot, 'approve')}>
              ✓ Approve
            </button>
            <button className="tr-btn-reject" onClick={() => openActionModal(pilot, 'reject')}>
              ✗ Reject
            </button>
            <button className="tr-btn-view" onClick={() => handleViewClick(pilot)}>
              👁️ View
            </button>
          </div>
        );
        
      case "approved":
        return (
          <div className="tr-action-buttons">
            <button className="tr-btn-reject" onClick={() => openActionModal(pilot, 'reject')}>
              ✗ Reject & Block
            </button>
            <button className="tr-btn-view" onClick={() => handleViewClick(pilot)}>
              👁️ View
            </button>
          </div>
        );
        
      case "rejected":
      case "blocked":
        return (
          <div className="tr-action-buttons">
            <button className="tr-btn-approve" onClick={() => openActionModal(pilot, 'approve')}>
              ✓ Approve
            </button>
            <button className="tr-btn-view" onClick={() => handleViewClick(pilot)}>
              👁️ View
            </button>
          </div>
        );
        
      default:
        return (
          <div className="tr-action-buttons">
            <button className="tr-btn-view" onClick={() => handleViewClick(pilot)}>
              👁️ View
            </button>
          </div>
        );
    }
  };

  const getCardStyle = (pilot) => {
    if (pilot.status === "pending") return "tr-card-pending";
    if (pilot.status === "approved") return "tr-card-approved";
    if (pilot.status === "rejected") return "tr-card-rejected";
    return "";
  };

  const getRowStyle = (pilot) => {
    if (pilot.status === "pending") return "tr-row-pending";
    if (pilot.status === "approved") return "tr-row-approved";
    if (pilot.status === "rejected") return "tr-row-rejected";
    return "";
  };

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      <PopupMessage isOpen={popupOpen} onClose={() => setPopupOpen(false)} message={popupMessage} type={popupType} />

      <div className="dashboard-content">
        <div className="tr-header">
          <div className="tr-header-main">
            <div className="tr-header-title-section">
              <h1 className="dashboard-title">Pilot Management</h1>
              <div className="dashboard-subtitle">Manage pilot registrations and access permissions</div>
            </div>
          </div>
        </div>

        <div className="tr-filter-bar">
          <div className="tr-filter-tabs">
            <button className={`tr-filter-tab ${filter === "all" ? "tr-active" : ""}`} onClick={() => setFilter("all")}>
              All Pilots ({statusCounts.all})
            </button>
            <button className={`tr-filter-tab ${filter === "pending" ? "tr-active" : ""}`} onClick={() => setFilter("pending")}>
              Pending ({statusCounts.pending})
            </button>
            <button className={`tr-filter-tab ${filter === "approved" ? "tr-active" : ""}`} onClick={() => setFilter("approved")}>
              Approved ({statusCounts.approved})
            </button>
            <button className={`tr-filter-tab ${filter === "rejected" ? "tr-active" : ""}`} onClick={() => setFilter("rejected")}>
              Rejected ({statusCounts.rejected})
            </button>
          </div>
          <div className="tr-view-controls">
            <div className="tr-view-toggle">
              <button className={`tr-view-btn ${viewMode === "grid" ? "tr-active" : ""}`} onClick={() => setViewMode("grid")}>
                ⏹️
              </button>
              <button className={`tr-view-btn ${viewMode === "list" ? "tr-active" : ""}`} onClick={() => setViewMode("list")}>
                ≡
              </button>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="custom-loading-container">
            <img src={pavamanLogo} alt="Loading" className="spinning-logo" />
            <p className="loading-text">Loading team requests data...</p>
          </div>
        ) : (
          <>
            {viewMode === "grid" ? (
              <>
                <div className="tr-grid">
                  {currentRequests.map((pilot) => (
                    <div key={pilot.id} className={`tr-card ${getCardStyle(pilot)}`}>
                      <div className="tr-card-header">
                        <div className="tr-avatar" style={{ background: pilot.statusColor }}>
                          {pilot.firstName?.charAt(0) || pilot.name?.charAt(0) || "P"}
                        </div>
                        <div className="tr-card-info">
                          <div className="tr-card-name-row">
                            <h3 className="tr-card-name">{pilot.name}</h3>
                            <span className="tr-status-badge" style={{ background: pilot.statusBg, color: pilot.statusColor }}>
                              {pilot.statusIcon} {pilot.statusLabel}
                            </span>
                          </div>
                          <p className="tr-card-email">{pilot.email}</p>
                          <div className="tr-card-meta">
                            <span className="tr-meta-item">📱 {formatMobile(pilot.mobile_no)}</span>
                            {pilot.company_name && (
                              <span className="tr-meta-item">🏢 {pilot.company_name}</span>
                            )}
                            {pilot.admin_name && (
                              <span className="tr-meta-item">👤 {pilot.admin_name}</span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="tr-card-details">
                        <div className="tr-detail-row">
                          <span className="tr-detail-label">Registered:</span>
                          <span className="tr-detail-value">{formatDate(pilot.created_on)}</span>
                        </div>
                        {pilot.is_dgca_company === true && (
  <div className="tr-detail-row">
    <span className="tr-detail-label">Signup Key:</span>
    <span className="tr-detail-value">
      {pilot.signup_key || "Not Set"}
    </span>
  </div>
)}
                        <div className="tr-detail-row">
                          <span className="tr-detail-label">Last Login:</span>
                          <span className="tr-detail-value">{formatDate(pilot.login_on)}</span>
                        </div>
                        {/* <div className="tr-detail-row">
  <span className="tr-detail-label">Latest Device:</span>
  <span className="tr-detail-value">
    {pilot.device_id || "Not Set"}
  </span>
</div> */}

<div className="tr-detail-row">
  <span className="tr-detail-label">Device Status:</span>
  <span
    className={`tr-detail-value ${
      pilot.is_active ? "tr-online" : "tr-offline"
    }`}
  >
    {pilot.is_active ? "Active" : "Inactive"}
  </span>
</div>
                        <div className="tr-detail-row">
                          <span className="tr-detail-label">Login Status:</span>
                          <span className={`tr-detail-value ${pilot.login_status === true || pilot.login_status === 1 ? "tr-online" : "tr-offline"}`}>
                            {pilot.login_status === true || pilot.login_status === 1 ? "Online" : "Offline"}
                          </span>
                        </div>
                      </div>
                      <div className="tr-card-divider"></div>
                      {renderActionButtons(pilot)}
                    </div>
                  ))}
                </div>

                {filteredRequests.length > itemsPerPage && (
                  <div className="pagination-container">
                    <div className="pagination-controls">
                      <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        ← Previous
                      </button>
                      
                      <div className="page-numbers">
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                          let pageNumber;
                          if (totalPages <= 5) {
                            pageNumber = i + 1;
                          } else if (currentPage <= 3) {
                            pageNumber = i + 1;
                          } else if (currentPage >= totalPages - 2) {
                            pageNumber = totalPages - 4 + i;
                          } else {
                            pageNumber = currentPage - 2 + i;
                          }
                          
                          return (
                            <button
                              key={pageNumber}
                              className={`page-btn ${currentPage === pageNumber ? 'active' : ''}`}
                              onClick={() => setCurrentPage(pageNumber)}
                            >
                              {pageNumber}
                            </button>
                          );
                        })}
                      </div>
                      
                      <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                      >
                        Next →
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="tr-table-container">
                  <table className="tr-table">
                    <thead className="tr-thead">
                      <tr>
                        <th>Pilot</th>
                        <th>Contact</th>
                        <th>Status</th>
                        <th>Login Status</th>
                        {/* <th>Devices</th> */}
                        <th>Registered On</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRequests.map((pilot) => (
                        <tr key={pilot.id} className={getRowStyle(pilot)}>
                          <td>
                            <div className="tr-table-pilot">
                              <div className="tr-table-avatar" style={{ background: pilot.statusColor }}>
                                {pilot.firstName?.charAt(0) || pilot.name?.charAt(0) || "P"}
                              </div>
                              <div className="tr-table-pilot-info">
                                <div className="tr-table-name">{pilot.name}</div>
                                <div className="tr-table-email">{pilot.email}</div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="tr-table-contact">📱 {formatMobile(pilot.mobile_no)}</div>
                          </td>
                          <td>
                            <span className="tr-table-status" style={{ background: pilot.statusBg, color: pilot.statusColor }}>
                              {pilot.statusIcon} {pilot.statusLabel}
                            </span>
                          </td>
                          <td>
                            <div className={`tr-table-login ${pilot.login_status === true || pilot.login_status === 1 ? "tr-online" : "tr-offline"}`}>
                              <span className="tr-status-dot"></span>
                              {pilot.login_status === true || pilot.login_status === 1 ? "Online" : "Offline"}
                            </div>
                          </td>
                          {/* <td>
  <div className="tr-table-device-info">
    <span>
      {pilot.device_id || "Not Set"}
    </span>

    <span
      className={
        pilot.is_active
          ? "tr-online"
          : "tr-offline"
      }
    >
      {pilot.is_active ? "Active" : "Inactive"}
    </span>
  </div>
</td> */}
                          <td>
                            <div className="tr-table-date">{formatDate(pilot.created_on)}</div>
                          </td>
                          <td>
                            <div className="tr-table-actions">
                              {pilot.status === "pending" && (
                                <>
                                  <button onClick={() => openActionModal(pilot, 'approve')} className="tr-table-btn tr-btn-approve" title="Approve">✓</button>
                                  <button onClick={() => openActionModal(pilot, 'reject')} className="tr-table-btn tr-btn-reject" title="Reject">✗</button>
                                </>
                              )}
                              {pilot.status === "approved" && (
                                <button onClick={() => openActionModal(pilot, 'reject')} className="tr-table-btn tr-btn-reject" title="Reject & Block">✗</button>
                              )}
                              {(pilot.status === "rejected" || pilot.status === "blocked") && (
                                <button onClick={() => openActionModal(pilot, 'approve')} className="tr-table-btn tr-btn-approve" title="Approve">✓</button>
                              )}
                              <button onClick={() => handleViewClick(pilot)} className="tr-table-btn tr-btn-view" title="View">👁️</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {filteredRequests.length > itemsPerPage && (
                  <div className="pagination-container">
                    <div className="pagination-controls">
                      <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        ← Previous
                      </button>
                      
                      <div className="page-numbers">
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                          let pageNumber;
                          if (totalPages <= 5) {
                            pageNumber = i + 1;
                          } else if (currentPage <= 3) {
                            pageNumber = i + 1;
                          } else if (currentPage >= totalPages - 2) {
                            pageNumber = totalPages - 4 + i;
                          } else {
                            pageNumber = currentPage - 2 + i;
                          }
                          
                          return (
                            <button
                              key={pageNumber}
                              className={`page-btn ${currentPage === pageNumber ? 'active' : ''}`}
                              onClick={() => setCurrentPage(pageNumber)}
                            >
                              {pageNumber}
                            </button>
                          );
                        })}
                      </div>
                      
                      <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                      >
                        Next →
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
            {filteredRequests.length === 0 && (
              <div className="tr-no-results">
                <div className="tr-no-results-icon">👨‍✈️</div>
                <h3>No pilots found</h3>
                <p>Try adjusting your search or filter criteria</p>
              </div>
            )}
          </>
        )}
      </div>

      {showActionModal && actionPilot && (
        <div className="tr-modal-overlay" onClick={closeActionModal}>
          <div className="tr-modal-content tr-modal-small" onClick={(e) => e.stopPropagation()}>
            <div className="tr-modal-header">
              <h2>{actionType === 'approve' ? 'Approve Pilot' : 'Reject Pilot'}</h2>
              <button className="tr-modal-close" onClick={closeActionModal} disabled={isActionProcessing}>✕</button>
            </div>
            <div className="tr-modal-body">
              <div className="tr-confirm-container">
                <div className={`tr-confirm-icon ${actionType === 'approve' ? 'tr-confirm-approve' : 'tr-confirm-reject'}`}>
                  {actionType === 'approve' ? '✓' : '✗'}
                </div>
                <p className="tr-confirm-text">
                  Are you sure you want to {actionType} <strong>{actionPilot.name}</strong>?
                </p>
                <p className="tr-confirm-subtext">
                  {actionType === 'approve' 
                    ? 'The pilot will be able to access the platform and use their device.' 
                    : 'The pilot will be rejected and their device will be blocked. They will not be able to access the platform.'}
                </p>
                <div className="tr-confirm-buttons">
                  <button 
                    className="tr-confirm-cancel" 
                    onClick={closeActionModal}
                    disabled={isActionProcessing}
                  >
                    Cancel
                  </button>
                  <button 
                    className={actionType === 'approve' ? 'tr-confirm-approve-btn' : 'tr-confirm-reject-btn'}
                    onClick={() => handleStatusUpdate(actionPilot, actionType)}
                    disabled={isActionProcessing}
                  >
                    {isActionProcessing ? (
                      <>
                        <span className="tr-spinner-small"></span>
                        Processing...
                      </>
                    ) : (
                      `Yes, ${actionType === 'approve' ? 'Approve' : 'Reject'}`
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamRequests;